import { render, staticRenderFns } from "./ManageDocuments.vue?vue&type=template&id=1a39d294"
import script from "./ManageDocuments.vue?vue&type=script&lang=js"
export * from "./ManageDocuments.vue?vue&type=script&lang=js"
import style0 from "./ManageDocuments.vue?vue&type=style&index=0&id=1a39d294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports